import script from "./FloatActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatActionButton.vue?vue&type=script&setup=true&lang=js"

import "./FloatActionButton.vue?vue&type=style&index=0&id=d033fde8&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d033fde8"]])

export default __exports__